import * as React from "react";
import * as style from "./cta.module.scss";
import { GatsbyImage } from "gatsby-plugin-image";
import PropTypes from "prop-types";
import Link from "components/Link";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const Cta = ({
  link,
  img,
  alt = "",
  title,
  description,
  flexWidth,
  light,
  bounded,
  className,
}) => {
  return (
    <Link
      to={link}
      className={`
        ${style.Cta} 
        ${className ? className : ""} 
        ${flexWidth ? style.Cta___flexWidth : ""}
        ${light ? style.Cta___light : ""}
        ${bounded ? style.Cta___bounded : ""}
      `.trim()}
    >
      {img && <GatsbyImage image={img} alt={alt} className={style.Cta_img} />}
      <div className={style.Cta_content}>
        <div>
          <h3 className={style.Cta_title}>{title}</h3>
          {description && (
            <p className={style.Cta_description}>{description}</p>
          )}
        </div>
        <div>
          <div className={style.Cta_arrow}>
            <ArrowForwardIcon />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default Cta;

Cta.propTypes = {
  link: PropTypes.string,
  img: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  alt: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  flexWidth: PropTypes.bool,
  light: PropTypes.bool,
  bounded: PropTypes.bool,
  className: PropTypes.string,
};

Cta.defaultProps = {
  alt: "",
};

Cta.displayName = "Cta";
